import { Component, HostListener, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Menu, NavService } from '../../services/nav.service';
import { LayoutService } from '../../services/layout.service';
import { Project } from '../../models/project';
import { ProjectService } from '../../services/project.service';
import { GlobalAllConfigComponents, GlobalApps, GlobalAppsSortedByOrder, GlobalVariable } from '../../helpers/settings';
import { UserService } from '../../services/user.service';
import { AuthService } from '../../services/auth.service';
import { cloneDeep } from 'lodash';
import { RoleService } from '../../services/user-role.service';
import { User } from '../../models/user';
import { Role } from '../../models/user-role';
import { Subscription } from '../../models/subscription';
import { Subscription as Unsubscriptions } from 'rxjs';
import { SubscriptionService } from '../../services/subscription.service';
import { AppConfigService } from '../../services/app-config.service';

@Component({
	selector: 'app-sidebar',
	templateUrl: './sidebar.component.html',
	styleUrls: ['./sidebar.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class SidebarComponent implements OnInit, OnDestroy {
	public menuItems: Menu[] = [];
	public projects: Project[] = [];
	public url: any;
	public currentUser: Partial<User> = {
		username: undefined,
		email: undefined,
		firstName: undefined,
		roles: [],
		userRole: { role: undefined },
		salary: undefined,
		lastName: undefined,
		phoneNumber: undefined,
		address: undefined,
		password: undefined,
		imageUrl: undefined,
		city: undefined,
		active: true,
		project: undefined,
		subscription: undefined
	};
	public currentUserRole: Partial<Role> = {
		name: undefined,
		access: []
	};

	// For Horizontal Menu
	public margin: any = 0;
	public width: any = window.innerWidth;
	public leftArrowNone: boolean = true;
	public rightArrowNone: boolean = false;
	private allConfigRoutes = [];
	private allProjectRoutes = [];
	private unSubscriptions: Unsubscriptions[] = [];

	constructor(
		private router: Router,
		public navServices: NavService,
		public layout: LayoutService,
		private projectService: ProjectService,
		private userService: UserService,
		private subscriptionService: SubscriptionService,
		private authService: AuthService,
		private roleService: RoleService,
		private appConfig: AppConfigService
	) {}

	ngOnInit() {
		this.initAllProjectRoutes();
		this.getMenuItems();
	}

	ngOnDestroy() {
		this.unSubscriptions.forEach(sub => sub.unsubscribe());
	}

	@HostListener('window:resize', ['$event'])
	onResize(event) {
		this.width = event.target.innerWidth - 500;
	}

	sidebarToggle() {
		this.navServices.collapseSidebar = !this.navServices.collapseSidebar;
	}

	private initAllProjectRoutesOldVersion() {
		this.currentUser = this.userService.getCurrentUserInfos();
		const currentSubscription = this.currentUser.subscription as Subscription;
		this.appConfig.load(this.currentUser);
		const activatedApps = GlobalApps.filter(app => currentSubscription?.applications?.includes(app.code));
		// start the menu with the dashboard
		activatedApps.unshift(GlobalVariable['DASHBOARD']);
		this.allProjectRoutes = activatedApps?.map(app => {
			const route = {
				title: app.route !== 'dashboard' ? this.appConfig.getAppTitle(app?.code) : app.title,
				name: app.name,
				route: app.route,
				code: app?.code,
				childRoute: app?.childRoute,
				svgIcon: app?.svgIcon
			};
			switch (app.route) {
				case 'shipping-management':
					return {
						...route,
						type: 'sub',
						badgeType: 'light-primary',
						badgeValue: null,
						active: false,
						children: [
							{ path: `/front/${app.route}/` + ':projectId' + '/list', title: 'List', type: 'link' },
							{
								path: `/front/${app.route}/` + ':projectId' + '/pickup',
								title: 'Pickup Requests',
								childRoute: 'pickup',
								type: 'link'
							},
							{
								path: `/front/${app.route}/` + ':projectId' + '/histories',
								title: 'Histories',
								childRoute: 'histories',
								type: 'link'
							},
							{
								path: `/front/${app.route}/` + ':projectId' + '/cities',
								title: 'Cities',
								childRoute: 'Cities',
								type: 'link'
							}
						]
					};
					break;
				case 'booking-management':
					return {
						...route,
						type: 'sub',
						badgeType: 'light-primary',
						badgeValue: null,
						active: false,
						children: [
							{ path: `/front/${app.route}/` + ':projectId' + '/list', title: 'List', type: 'link' },
							{
								path: `/front/${app.route}/` + ':projectId' + '/calendar',
								title: 'Calendar',
								childRoute: 'calendar',
								type: 'link'
							},
							{
								path: `/front/${app.route}/` + ':projectId' + '/histories',
								title: 'Histories',
								childRoute: 'histories',
								type: 'link'
							}
						]
					};
					break;
				case 'transaction-management':
					return {
						...route,
						type: 'sub',
						badgeType: 'light-primary',
						badgeValue: null,
						active: false,
						children: [
							{ path: `/front/${app.route}/` + ':projectId' + '/list', title: 'List', type: 'link' },
							{
								path: `/front/${app.route}/` + ':projectId' + '/histories',
								title: 'Histories',
								childRoute: 'histories',
								type: 'link'
							}
						]
					};
					break;
				case 'stock-management':
					return {
						...route,
						type: 'sub',
						badgeType: 'light-primary',
						badgeValue: null,
						active: false,
						children: [
							{ path: `/front/${app.route}/` + ':projectId' + '/list', title: 'Stock', type: 'link' },
							{
								path: `/front/${app.route}/` + ':projectId' + '/histories',
								title: 'Histories',
								childRoute: 'histories',
								type: 'link'
							}
						]
					};
					break;
				case 'expense-management':
					return {
						...route,
						type: 'sub',
						badgeType: 'light-primary',
						badgeValue: null,
						active: false,
						children: [
							{
								path: `/front/${app.route}/` + ':projectId' + '/list',
								title: 'Expenses',
								type: 'link'
							},
							{
								path: `/front/${app.route}/` + ':projectId' + '/calculator',
								title: 'Calculator',
								childRoute: 'calculator',
								type: 'link'
							},
							{
								path: `/front/${app.route}/` + ':projectId' + '/histories',
								title: 'Histories',
								childRoute: 'histories',
								type: 'link'
							}
						]
					};
					break;
				case 'human-resource':
					return {
						...route,
						type: 'sub',
						badgeType: 'light-primary',
						badgeValue: null,
						active: false,
						children: [],
						childApp: [
							{
								path: `/front/${app.route}` + '/:projectId' + '/salary',
								title: this.appConfig.getAppTitle('SALARY_MANAGEMENT'),
								name: GlobalVariable['SALARY_MANAGEMENT']?.name,
								type: 'link'
							},
							{
								path: `/front/${app.route}` + '/:projectId' + '/absence',
								title: this.appConfig.getAppTitle('ABSENCE_TRACKER'),
								name: GlobalVariable['ABSENCE_TRACKER']?.name,
								type: 'link'
							},
							{
								path: `/front/${app.route}` + '/:projectId' + '/salary-histories',
								title: this.appConfig.getAppTitle('SALARY_HISTORY'),
								name: GlobalVariable['SALARY_HISTORY']?.name,
								type: 'link'
							}
						]
					};
					break;
				case 'turnover-management':
					return {
						...route,
						type: 'sub',
						badgeType: 'light-primary',
						badgeValue: null,
						active: false,
						children: [
							{
								path: `/front/${app.route}/` + ':projectId' + '/list',
								title: 'Turnover',
								type: 'link'
							},
							{
								path: `/front/${app.route}/` + ':projectId' + '/histories',
								title: 'Histories',
								childRoute: 'histories',
								type: 'link'
							}
						]
					};
					break;
				case 'orders-management':
					return {
						...route,
						type: 'sub',
						badgeType: 'light-primary',
						badgeValue: null,
						active: false,
						children: [
							{ path: `/front/${app.route}/` + ':projectId' + '/list', title: 'List', type: 'link' },
							{
								path: `/front/${app.route}/` + ':projectId' + '/calculator',
								title: 'Calculator',
								childRoute: 'calculator',
								type: 'link'
							}
						]
					};
				default:
					// return route result as format : { name, title, path, type }
					return {
						...route,
						path: `/front/${app.route}/`,
						type: 'link'
					};
			}
		});
	}

	private initAllProjectRoutes() {
		this.currentUser = this.userService.getCurrentUserInfos();
		const currentSubscription = this.currentUser.subscription as Subscription;
		this.appConfig.load(this.currentUser);
		const activatedApps = GlobalAppsSortedByOrder.filter(app =>
			currentSubscription?.applications?.includes(app.code)
		);
		// start the menu with the dashboard
		activatedApps.unshift(GlobalVariable['DASHBOARD']);
		this.allProjectRoutes = activatedApps
			?.map(app => {
				const route = {
					title: app.route !== 'dashboard' ? this.appConfig.getAppTitle(app?.code) : app.title,
					name: app.name,
					route: app.route,
					code: app.route === 'dashboard' ? 'DASHBOARD' : app?.code,
					childRoute: app?.childRoute,
					svgIcon: app?.svgIcon,
					svgImage: app?.svgImage,
					model: app?.model,
					linkedConfigs: app?.linkedConfigs ?? [],
					appCode: null,
					hasDisplayed: false
				};
				switch (app.route) {
					case 'shipping-management':
						return {
							...route,
							type: 'sub',
							badgeType: 'light-primary',
							badgeValue: null,
							active: false,
							children: [
								{
									path: `/front/${app.route}/` + ':projectId' + '/list',
									title: this.appConfig.getAppTitle(app?.code),
									svgImage: 'delivery-truck',
									code: app?.code,
									appCode: app?.code,
									type: 'link'
								},
								{
									path: `/front/${app.route}/` + ':projectId' + '/pickup',
									title: 'Pickup Requests',
									childRoute: 'pickup',
									svgImage: 'pickup-request-2',
									code: 'PICKUP_REQUEST',
									appCode: app?.code,
									type: 'link'
								},
								{
									path: `/front/${app.route}/` + ':projectId' + '/histories',
									title: 'Histories',
									code: 'Histories',
									appCode: app?.code,
									svgImage: 'history',
									childRoute: 'histories',
									type: 'link'
								}
							]
						};
						break;
					case 'booking-management':
						return {
							...route,
							type: 'sub',
							badgeType: 'light-primary',
							badgeValue: null,
							active: false,
							children: [
								{
									path: `/front/${app.route}/` + ':projectId' + '/list',
									title: this.appConfig.getAppNickName(app?.code),
									code: app?.code,
									appCode: app?.code,
									svgIcon: app?.svgIcon,
									type: 'link'
								},
								{
									path: `/front/${app.route}/` + ':projectId' + '/calendar',
									title: 'Calendar',
									code: 'CALENDAR',
									appCode: app?.code,
									childRoute: 'calendar',
									svgIcon: app?.svgIcon,
									type: 'link'
								},
								{
									path: `/front/${app.route}/` + ':projectId' + '/histories',
									title: 'Histories',
									code: 'Histories',
									appCode: app?.code,
									childRoute: 'histories',
									svgImage: 'history',
									type: 'link'
								}
							]
						};
						break;
					case 'transaction-management':
						return {
							...route,
							type: 'sub',
							badgeType: 'light-primary',
							badgeValue: null,
							active: false,
							children: [
								{
									path: `/front/${app.route}/` + ':projectId' + '/list',
									title: this.appConfig.getAppNickName(app?.code),
									code: app?.code,
									appCode: app?.code,
									svgImage: app?.svgImage,
									type: 'link'
								},
								{
									path: `/front/${app.route}/` + ':projectId' + '/histories',
									title: 'Histories',
									code: 'Histories',
									appCode: app?.code,
									svgImage: 'history',
									childRoute: 'histories',
									type: 'link'
								}
							]
						};
						break;
					case 'stock-management':
						return {
							...route,
							type: 'sub',
							badgeType: 'light-primary',
							title: 'Purchase',
							badgeValue: null,
							active: false,
							children: [
								{
									path: `/front/${app.route}/` + ':projectId' + '/list',
									title: this.appConfig.getAppNickName(app?.code),
									code: app?.code,
									appCode: app?.code,
									svgIcon: app?.svgIcon,
									type: 'link'
								},
								{
									path: `/front/${app.route}/` + ':projectId' + '/supplier-purchase',
									title: 'Create a purchase order',
									code: 'CREATE_PURCHASE_ORDER',
									appCode: app?.code,
									childRoute: 'supplier-purchase',
									svgImage: 'laptop',
									type: 'link'
								},
								// {
								// 	path: `/front/${app.route}/` + ':projectId' + '/list',
								// 	title: this.appConfig.getAppNickName(app?.code) + ' Expire',
								// 	queryParams: { filter: 'expire' },
								// 	code: 'STOCK_EXPIRE',
								// 	svgIcon: 'stroke-faq',
								// 	type: 'link'
								// },
								// {
								// 	path: `/front/${app.route}/` + ':projectId' + '/list',
								// 	title: 'Low Stock',
								// 	code: 'LOW_STOCK',
								// 	queryParams: { qte: 'low' },
								// 	svgImage: 'low-stock',
								// 	type: 'link'
								// },
								{
									path:
										`/front/${GlobalVariable['INVOICE_MANAGEMENT'].route}/` +
										':projectId' +
										'/list',
									title: 'Purchase Order',
									code: 'PURCHASE_ORDER',
									appCode: GlobalVariable['INVOICE_MANAGEMENT'].code,
									queryParams: { model: 'purchase-order' },
									svgIcon: GlobalVariable['INVOICE_MANAGEMENT']?.svgIcon,
									type: 'link'
								},
								{
									path:
										`/front/${GlobalVariable['INVOICE_MANAGEMENT'].route}/` +
										':projectId' +
										'/list',
									title: 'Entry Slip',
									code: 'ENTRY_SLIP',
									appCode: GlobalVariable['INVOICE_MANAGEMENT'].code,
									queryParams: { model: 'entry-slip' },
									svgIcon: GlobalVariable['INVOICE_MANAGEMENT']?.svgIcon,
									type: 'link'
								},
								{
									path:
										`/front/${GlobalVariable['INVOICE_MANAGEMENT'].route}/` +
										':projectId' +
										'/list',
									title: 'Receiving Slip',
									code: 'RECEIVING_SLIP',
									appCode: GlobalVariable['INVOICE_MANAGEMENT'].code,
									queryParams: { model: 'receiving-slip' },
									svgIcon: GlobalVariable['INVOICE_MANAGEMENT']?.svgIcon,
									type: 'link'
								},
								{
									path:
										`/front/${GlobalVariable['INVOICE_MANAGEMENT'].route}/` +
										':projectId' +
										'/list',
									title: 'Return Slip',
									code: 'RETURN_SLIP',
									appCode: GlobalVariable['INVOICE_MANAGEMENT'].code,
									queryParams: { model: 'return-slip' },
									svgIcon: GlobalVariable['INVOICE_MANAGEMENT']?.svgIcon,
									type: 'link'
								},
								{
									path: `/front/${app.route}/` + ':projectId' + '/histories',
									title: 'Histories',
									code: 'Histories',
									svgImage: 'history',
									childRoute: 'histories',
									type: 'link'
								}
							]
						};
						break;
					case 'expense-management':
						return {
							...route,
							title: 'Finance',
							type: 'sub',
							badgeType: 'light-primary',
							badgeValue: null,
							active: false,
							children: [
								{
									path: `/front/${app.route}/` + ':projectId' + '/list',
									title: this.appConfig.getAppNickName(app?.code),
									svgIcon: app?.svgIcon,
									code: app?.code,
									appCode: app?.code,
									type: 'link'
								},
								{
									path: `/front/${app.route}/` + ':projectId' + '/calculator',
									title: 'Expense Calculator',
									code: 'EXPENSE_CALCULATOR',
									appCode: app?.code,
									svgImage: 'calculator',
									childRoute: 'calculator',
									type: 'link'
								},
								{
									path: `/front/${app.route}/` + ':projectId' + '/histories',
									title: 'Histories',
									code: 'Histories',
									appCode: app?.code,
									svgImage: 'history',
									childRoute: 'histories',
									type: 'link'
								},
								{
									path: `/front/${GlobalVariable['CASH_JOURNAL'].route}/` + ':projectId',
									title: this.appConfig.getAppNickName(GlobalVariable['CASH_JOURNAL'].code),
									svgIcon: GlobalVariable['CASH_JOURNAL']?.svgIcon,
									code: GlobalVariable['CASH_JOURNAL']?.code,
									appCode: GlobalVariable['CASH_JOURNAL']?.code,
									type: 'link'
								},
								{
									path:
										`/front/${GlobalVariable['INVOICE_MANAGEMENT'].route}/` +
										':projectId' +
										'/list',
									title: 'Check',
									code: 'CHEQUE',
									appCode: GlobalVariable['INVOICE_MANAGEMENT']?.code,
									queryParams: { model: 'check' },
									svgIcon: GlobalVariable['INVOICE_MANAGEMENT']?.svgIcon,
									type: 'link'
								}
							]
						};
						break;
					case 'human-resource':
						return {
							...route,
							type: 'sub',
							badgeType: 'light-primary',
							badgeValue: null,
							active: false,
							children: [],
							childApp: [
								{
									path: `/front/${app.route}` + '/:projectId' + '/salary',
									title: this.appConfig.getAppTitle('SALARY_MANAGEMENT'),
									name: GlobalVariable['SALARY_MANAGEMENT']?.name,
									code: 'SALARY_MANAGEMENT',
									appCode: app.code,
									svgImage: GlobalVariable['SALARY_MANAGEMENT']?.svgImage,
									type: 'link'
								},
								{
									path: `/front/${app.route}` + '/:projectId' + '/absence',
									title: this.appConfig.getAppTitle('ABSENCE_TRACKER'),
									name: GlobalVariable['ABSENCE_TRACKER']?.name,
									code: 'ABSENCE_TRACKER',
									appCode: app.code,
									svgImage: GlobalVariable['ABSENCE_TRACKER']?.svgImage,
									type: 'link'
								},
								{
									path: `/front/${app.route}` + '/:projectId' + '/salary-histories',
									title: this.appConfig.getAppTitle('SALARY_HISTORY'),
									name: GlobalVariable['SALARY_HISTORY']?.name,
									code: 'SALARY_HISTORY',
									appCode: app.code,
									svgImage: 'history',
									svgIcon: app?.svgIcon,
									type: 'link'
								}
							]
						};
						break;
					case 'turnover-management':
						return {
							...route,
							type: 'sub',
							badgeType: 'light-primary',
							badgeValue: null,
							active: false,
							children: [
								{
									path: `/front/${app.route}/` + ':projectId' + '/list',
									title: this.appConfig.getAppNickName(GlobalVariable['TURNOVER_MANAGEMENT'].code),
									code: app?.code,
									svgImage: app?.svgImage,
									type: 'link'
								},
								{
									path: `/front/${app.route}/` + ':projectId' + '/histories',
									title: 'Histories',
									code: 'Histories',
									svgImage: 'history',
									childRoute: 'histories',
									type: 'link'
								}
							]
						};
						break;
					case 'orders-management':
						return {
							...route,
							title: 'Sales',
							type: 'sub',
							badgeType: 'light-primary',
							badgeValue: null,
							active: false,
							children: [
								{
									path: `/front/${app.route}/` + ':projectId' + '/add',
									title: 'POS',
									code: 'POS',
									appCode: app?.code,
									childRoute: 'add',
									svgImage: 'laptop',
									type: 'link'
								},
								{
									path: `/front/${app.route}/` + ':projectId' + '/list',
									title: 'Orders',
									code: app.code,
									appCode: app?.code,
									svgIcon: app?.svgIcon,
									type: 'link'
								},
								{
									path:
										`/front/${GlobalVariable['INVOICE_MANAGEMENT'].route}/` +
										':projectId' +
										'/list',
									title: 'Delivery voucher',
									code: 'DELIVERY_VOUCHER',
									appCode: GlobalVariable['INVOICE_MANAGEMENT']?.code,
									queryParams: { model: 'delivery-voucher' },
									svgIcon: GlobalVariable['INVOICE_MANAGEMENT']?.svgIcon,
									type: 'link'
								},
								{
									path:
										`/front/${GlobalVariable['INVOICE_MANAGEMENT'].route}/` +
										':projectId' +
										'/list',
									title: 'Credit Memo',
									code: 'CREDIT_MEMO',
									appCode: GlobalVariable['INVOICE_MANAGEMENT']?.code,
									queryParams: { model: 'credit-memo' },
									svgIcon: GlobalVariable['INVOICE_MANAGEMENT']?.svgIcon,
									type: 'link'
								},
								{
									path:
										`/front/${GlobalVariable['INVOICE_MANAGEMENT'].route}/` +
										':projectId' +
										'/list',
									title: 'Quote',
									code: 'QUOTE',
									appCode: GlobalVariable['INVOICE_MANAGEMENT']?.code,
									queryParams: { model: 'quote' },
									svgIcon: GlobalVariable['INVOICE_MANAGEMENT']?.svgIcon,
									type: 'link'
								},
								{
									path:
										`/front/${GlobalVariable['INVOICE_MANAGEMENT'].route}/` +
										':projectId' +
										'/list',
									title: 'Proforma invoice',
									code: 'PROFORMA_INVOICE',
									appCode: GlobalVariable['INVOICE_MANAGEMENT']?.code,
									queryParams: { model: 'proforma-invoice' },
									svgIcon: GlobalVariable['INVOICE_MANAGEMENT']?.svgIcon,
									type: 'link'
								},
								{
									path:
										`/front/${GlobalVariable['INVOICE_MANAGEMENT'].route}/` +
										':projectId' +
										'/list',
									title: 'Invoice',
									code: 'INVOICE',
									appCode: GlobalVariable['INVOICE_MANAGEMENT']?.code,
									queryParams: { model: 'invoice' },
									svgIcon: GlobalVariable['INVOICE_MANAGEMENT']?.svgIcon,
									type: 'link'
								},
								{
									path: `/front/${app.route}/` + ':projectId' + '/calculator',
									title: 'Order Calculator',
									code: 'ORDER_CALCULATOR',
									appCode: app?.code,
									svgImage: 'calculator',
									childRoute: 'calculator',
									type: 'link'
								},
								{
									path: `/front/${GlobalVariable['VENDOR_MANAGEMENT']?.route}/` + ':projectId',
									title: 'Client',
									code: 'CLIENT',
									appCode: GlobalVariable['VENDOR_MANAGEMENT']?.code,
									svgImage: 'users-group',
									queryParams: { role: 'client' },
									type: 'link'
								},
								{
									path:
										`/front/${GlobalVariable['VENDOR_MANAGEMENT']?.route}/` + ':projectId' + '/add',
									title: 'Add Client',
									code: 'ADD_CLIENT',
									appCode: GlobalVariable['VENDOR_MANAGEMENT']?.code,
									childRoute: 'add',
									svgImage: 'add',
									queryParams: { role: 'client' },
									type: 'link'
								}
							]
						};
					case 'vendor-management':
						return {
							...route,
							type: 'sub',
							badgeType: 'light-primary',
							badgeValue: null,
							active: false,
							children: [
								{
									path: `/front/${app.route}/` + ':projectId' + '/list',
									title: this.appConfig.getAppNickName(app?.code),
									code: app?.code,
									appCode: app?.code,
									svgImage: app?.svgImage,
									type: 'link'
								},
								{
									path: `/front/${app.route}/` + ':projectId' + '/transactions',
									title: 'Transactions',
									code: 'TRANSACTIONS',
									appCode: app?.code,
									childRoute: 'transactions',
									svgImage: 'transaction',
									type: 'link'
								},
								{
									path: `/front/${app.route}/` + ':projectId' + '/add',
									title: 'Add ' + this.appConfig.getAppNickName(app?.code),
									code: 'ADD_TRANSACTIONS',
									appCode: app?.code,
									childRoute: 'add',
									svgImage: 'add',
									type: 'link'
								}
							]
						};
						break;
					case 'cash-journal':
						return {
							...route,
							path: `/front/${app.route}/`,
							type: 'link',
							hasDisplayed: true
						};
					default:
						// return route result as format : { name, title, path, type }
						return {
							...route,
							path: `/front/${app.route}/`,
							type: 'link'
						};
				}
			})
			.filter(app => !app?.hasDisplayed);
	}

	private initAllConfigRoutes() {
		this.allConfigRoutes = GlobalAllConfigComponents?.filter(
			configComponent => !['PROJECT', 'USER', 'ROLE', 'CUSTOM_TYPES'].includes(configComponent?.code)
		).map(config => {
			const route = {
				code: config.code,
				title:
					config.isModel && !config.isChildModel && !config?.childComponents?.length
						? this.appConfig.getAppNickName(config?.appCode) + ' ' + 'Model'
						: config.title,
				name: config.name,
				route: config.route,
				isModel: config.isModel,
				appCode: config.appCode ?? null,
				svgIcon: config?.svgIcon ?? null,
				svgImage: config?.svgImage ?? null,
				linkedApps: config?.linkedApps ?? [],
				linkedConfigs: config?.linkedConfigs ?? [],
				parentComponentRoute: config?.parentComponentRoute ?? null,
				moduleName: config?.moduleName ?? null,
				hasDisplayed: false,
				isForLinkedApp: false
			};
			switch (config.route) {
				case 'applications':
					return {
						...route,
						path: `/admin/${config.route}/`,
						type: 'link',
						roles: ['Owner', 'Admin', 'SuperAdmin', 'User']
					};
					break;
				case 'employee':
					return {
						...route,
						isForLinkedApp: true,
						path: `/admin/${config.route}/`,
						type: 'link',
						svgImage: 'employee',
						roles: ['Owner', 'Admin', 'SuperAdmin', 'User']
					};
					break;
				case 'products':
					return {
						...route,
						path: `/admin/${config.route}/`,
						type: 'link',
						roles: ['Owner', 'Admin', 'SuperAdmin', 'User'],
						children: [
							{
								path: `/admin/${config.route}/`,
								title: config.title,
								code: config.code,
								type: 'link',
								svgIcon: config?.svgIcon
							},
							{
								path: `/admin/${config.route}/add`,
								title: 'Create Product',
								code: 'CREATE_PRODUCT',
								svgImage: 'add',
								type: 'link',
								icon: 'board'
							}
							// {
							// 	path: `/admin/${config.route}`,
							// 	title: 'Print Barre Code',
							// 	code: 'PRINT_BARRE_CODE',
							// 	svgImage: 'scan-barcode',
							// 	queryParams: { print: 'BarrCode' },
							// 	type: 'link',
							// 	icon: 'board'
							// },
							// {
							// 	path: `/admin/${config.route}`,
							// 	title: 'Print QrCode',
							// 	code: 'PRINT_QRCODE',
							// 	svgImage: 'qr-code-scan',
							// 	queryParams: { print: 'QrCode' },
							// 	type: 'link',
							// 	icon: 'board'
							// }
						]
					};
					break;
				case 'suppliers':
					return {
						...route,
						path: `/admin/${config.route}/`,
						type: 'link',
						roles: ['Owner', 'Admin', 'SuperAdmin', 'User'],
						children: [
							{
								path: `/admin/${config.parentComponentRoute}/`,
								title: config.title,
								code: config?.code,
								queryParams: { currentModel: 'Supplier' },
								type: 'link',
								svgIcon: 'stroke-user'
							},
							{
								path: `/admin/${config.parentComponentRoute}/${config.route}/add`,
								title: 'Create Supplier',
								code: 'CREATE_SUPPLIER',
								type: 'link',
								svgImage: 'add'
							}
						]
					};
					break;
				case 'loads':
					return {
						...route,
						title: 'Fixed charges'
					};
					break;
				default:
					// return route result as format : { name, title, path, type }
					return {
						...route,
						path: `/admin/${config.route}/`,
						type: 'link',
						roles: ['Owner', 'Admin', 'SuperAdmin', 'User']
					};
			}
		});
	}

	private getMenuItemsOldVersion() {
		this.menuItems = [];
		const sub = this.navServices.getMenuItems().subscribe(menuItems => {
			this.menuItems = menuItems;
			this.currentUser = this.userService.getCurrentUserInfos();
			if ((this.currentUser?.userRole?.role as Role)?._id) {
				this.currentUserRole = this.currentUser?.userRole?.role as Role;
			}
			this.getProjects();
			const routerSub = this.router.events.subscribe(event => {
				if (event instanceof NavigationEnd) {
					menuItems.filter(items => {
						if (items.path === event.url) {
							this.setNavActive(items);
						}
						if (!items.children) {
							return false;
						}
						items.children.filter(subItems => {
							if (subItems.path === event.url) {
								this.setNavActive(subItems);
							}
							if (!subItems.children) {
								return false;
							}
							subItems.children.filter(subSubItems => {
								if (subSubItems.path === event.url) {
									this.setNavActive(subSubItems);
								}
							});
						});
					});
				}
			});
			this.unSubscriptions.push(routerSub);
		});
		this.unSubscriptions.push(sub);
	}

	private getMenuItems() {
		this.menuItems = [];
		const sub = this.navServices.getMenuItems().subscribe(menuItems => {
			//this.menuItems = menuItems;
			this.currentUser = this.userService.getCurrentUserInfos();
			const currentSubscription = this.currentUser.subscription as Subscription;
			this.appConfig.load(this.currentUser);
			this.initAllConfigRoutes();
			if (this.allConfigRoutes?.length) {
				this.allConfigRoutes = this.allConfigRoutes.filter(route => {
					if (route?.isModel) {
						return currentSubscription?.applications.includes(route?.appCode);
					}
					return true;
				});
				if (this.currentUser.userRole?.role) {
					this.currentUserRole = this.currentUser.userRole?.role as Role;
					const hasAccessToComponents = this.currentUserRole.access.find(
						access =>
							access.config === 'Config' &&
							access.componentAccess.some(componentAccess => componentAccess?.isActive)
					);
					if (hasAccessToComponents && !this.roleService.hasOwnerAccess()) {
						this.allConfigRoutes = this.allConfigRoutes.filter(route => {
							const componentAccess = hasAccessToComponents.componentAccess.find(
								ComponentAccess =>
									ComponentAccess.route === (route?.parentComponentRoute ?? route.route)
							);
							if (route?.parentComponentRoute) {
								const childComponentAcces = componentAccess?.childComponents?.find(
									ComponentAccess => ComponentAccess.code === route.code
								);
								if (childComponentAcces?.isActive) {
									return true;
								}
								return false;
							}
							if (componentAccess?.isActive) {
								return true;
							}
							return false;
						});
					} else {
						this.allConfigRoutes = [];
					}
				}
			}
			this.menuItems = [];

			if ((this.currentUser?.userRole?.role as Role)?._id) {
				this.currentUserRole = this.currentUser?.userRole?.role as Role;
			}
			this.getProjects();
			const routerSub = this.router.events.subscribe(event => {
				if (event instanceof NavigationEnd) {
					menuItems.filter(items => {
						if (items.path === event.url) {
							this.setNavActive(items);
						}
						if (!items.children) {
							return false;
						}
						items.children.filter(subItems => {
							if (subItems.path === event.url) {
								this.setNavActive(subItems);
							}
							if (!subItems.children) {
								return false;
							}
							subItems.children.filter(subSubItems => {
								if (subSubItems.path === event.url) {
									this.setNavActive(subSubItems);
								}
							});
						});
					});
				}
			});
			this.unSubscriptions.push(routerSub);
		});
		this.unSubscriptions.push(sub);
	}

	// get projects
	private getProjects() {
		this.projectService.find(false, false, false, null, null, 'sidebar', null, 'find projects').subscribe(
			res => {
				this.projects = res;
				if (!this.projects?.length) {
					this.projectService.deleteCurrentProject();
				} else {
					this.fillMenu();
				}
			},
			err => {
				console.log(err.message);
			}
		);
	}

	private fillMenuOldVersion() {
		if (
			this.projects?.length &&
			!this.menuItems?.some(item => item?.headTitle1 === GlobalVariable['PROJECT']?.title)
		) {
			this.menuItems.push({
				headTitle1: GlobalVariable['PROJECT']?.title ?? 'Projects'
			});
		}
		for (let project of this.projects) {
			if (this.menuItems.some(item => item.projectId === project?._id)) continue;
			const hasAccessToComponents = this.currentUserRole.access.some(
				access =>
					access.project === project?._id &&
					access.componentAccess.some(componentAccess => componentAccess?.isActive)
			);
			if (!hasAccessToComponents && !this.roleService.hasOwnerAccess()) continue;
			this.menuItems.push({
				projectId: project?._id,
				title: project.name,
				icon: 'server',
				type: 'sub',
				badgeType: 'light-primary',
				badgeValue: null,
				active: false,
				children: this.getChildrenByUserRole(cloneDeep(this.allProjectRoutes), project)
			});
		}
	}

	private fillMenu() {
		const project = this.projectService.getCurrentProject();
		const hasAccessToComponents = this.currentUserRole.access.some(
			access =>
				access.project === project?._id &&
				access.componentAccess.some(componentAccess => componentAccess?.isActive)
		);
		if (!hasAccessToComponents && !this.roleService.hasOwnerAccess()) return;

		const sideBarApps = this.getChildrenByUserRole(cloneDeep(this.allProjectRoutes), project);
		const MenuSection: {
			headTitle: string;
			code: string;
			modules: any[];
		}[] = [];

		for (let app of sideBarApps) {
			let currentSection: {
				headTitle: string;
				code: string;
				modules: any[];
			} | null = null;
			// ------------
			currentSection = { headTitle: app?.title, code: app?.code, modules: [] };
			MenuSection.push(currentSection);
			// ------------
			if (app?.children?.length) {
				for (let children of app?.children) {
					const item = {
						title: children?.title,
						code: children?.code,
						icon: children?.svgIcon ?? null,
						imageIcon: children?.svgImage ?? null,
						type: 'link',
						path: `${children?.path}`,
						queryParams: children?.queryParams ?? {},
						projectId: project?._id,
						badgeValue: null,
						active: false
					};
					currentSection.modules.push(item);
				}
				app.hasDisplayed = true;
			} else {
				const item = {
					title: this.appConfig.getAppNickName(app?.code) ?? app?.title,
					code: app?.code,
					icon: app?.svgIcon ?? null,
					imageIcon: app?.svgImage ?? null,
					type: 'link',
					path: `${app?.path}`,
					projectId: project?._id,
					badgeValue: null,
					active: false
				};
				currentSection.modules.push(item);
				app.hasDisplayed = true;
			}
			if (app?.linkedConfigs?.length) {
				const linkedConfigs = this.allConfigRoutes.filter(config => app?.linkedConfigs?.includes(config?.code));
				for (let linkedConfig of linkedConfigs) {
					if (linkedConfig?.children?.length) {
						const items = linkedConfig?.children.map(item => ({
							...item,
							icon: item?.svgIcon ?? null,
							imageIcon: item?.svgImage ?? null,
							projectId: project?._id,
							badgeValue: null,
							active: false
						}));
						currentSection.modules.push(...items);
					} else {
						const item = {
							title: linkedConfig?.title,
							code: linkedConfig?.code,
							icon: linkedConfig?.svgIcon ?? null,
							imageIcon: linkedConfig?.svgImage ?? null,
							type: 'link',
							path: linkedConfig?.parentComponentRoute
								? `/admin/${linkedConfig?.parentComponentRoute}`
								: `/admin/${linkedConfig?.route}`,
							queryParams: linkedConfig?.parentComponentRoute
								? { currentModel: linkedConfig?.moduleName }
								: {},
							projectId: project?._id,
							badgeValue: null,
							active: false
						};
						currentSection.modules.push(item);
					}
					linkedConfig.hasDisplayed = true;
				}
			}
			if (app?.model) {
				const modelConfigs = this.allConfigRoutes.filter(config => config.appCode === app.code);
				for (let modelConfig of modelConfigs) {
					const item = {
						title: modelConfig.title,
						code: modelConfig?.code,
						icon: modelConfig?.svgIcon ?? null,
						imageIcon: modelConfig?.svgImage ?? null,
						type: 'link',
						path: `/admin/${modelConfig.route}/`,
						projectId: project?._id,
						badgeValue: null,
						active: false
					};
					currentSection.modules.push(item);
					modelConfig.hasDisplayed = true;
				}
			}
		}
		// affichage des configs restants
		const hasntDisplayedConfigs = this.allConfigRoutes.filter(
			configModule =>
				!configModule?.hasDisplayed &&
				!configModule?.isForLinkedApp &&
				!configModule?.hasLinkedApp?.length &&
				!(configModule?.parentComponentRoute && configModule?.linkedConfigs?.length)
		);
		for (let configModule of hasntDisplayedConfigs) {
			let currentSection: {
				headTitle: string;
				code: string;
				modules: any[];
			} | null = null;
			const cond =
				configModule.isModel &&
				(() => {
					const app = sideBarApps?.find(a => a?.code === configModule.appCode);
					return !app || app?.hasDisplayed;
				})();
			if (cond) continue;

			// ------------
			currentSection = { headTitle: configModule?.title, code: configModule?.code, modules: [] };
			MenuSection.push(currentSection);
			// ------------

			if (configModule?.children?.length) {
				for (let children of configModule?.children) {
					const item = {
						title: children?.title,
						code: children?.code,
						icon: children?.svgIcon ?? null,
						imageIcon: children?.svgImage ?? null,
						type: 'link',
						path: `${children?.path}`,
						queryParams: children?.queryParams ?? {},
						projectId: project?._id,
						badgeValue: null,
						active: false
					};
					currentSection.modules.push(item);
				}
			} else {
				const item = {
					title: configModule.title,
					code: configModule?.code,
					icon: configModule?.svgIcon ?? null,
					imageIcon: configModule?.svgImage ?? null,
					type: 'link',
					path: `/admin/${configModule.route}/`,
					projectId: project?._id,
					badgeValue: null,
					active: false
				};
				currentSection.modules.push(item);
			}
			configModule.hasDisplayed = true;
			if (configModule?.linkedConfigs?.length) {
				const linkedConfigModules = this.allConfigRoutes.filter(linkedConfigModule =>
					configModule?.linkedConfigs?.includes(linkedConfigModule?.code)
				);
				for (let linkedConfigModule of linkedConfigModules) {
					if (linkedConfigModule?.children?.length) {
						const items = linkedConfigModule?.children.map(item => ({
							...item,
							projectId: project?._id,
							badgeValue: null,
							active: false
						}));
						// this.menuItems.push(...items);
						currentSection.modules.push(...items);
					} else {
						const item = {
							title: linkedConfigModule?.title,
							code: linkedConfigModule?.code,
							icon: linkedConfigModule?.svgIcon ?? null,
							imageIcon: linkedConfigModule?.svgImage ?? null,
							type: 'link',
							path: linkedConfigModule?.parentComponentRoute
								? `/admin/${linkedConfigModule?.parentComponentRoute}`
								: `/admin/${linkedConfigModule?.route}`,
							queryParams: linkedConfigModule?.parentComponentRoute
								? { currentModel: linkedConfigModule?.moduleName }
								: {},
							projectId: project?._id,
							badgeValue: null,
							active: false
						};
						currentSection.modules.push(item);
					}
					linkedConfigModule.hasDisplayed = true;
				}
			}
		}
		// }
		const moduleOrder: Record<string, string[]> = {
			DASHBOARD: ['DASHBOARD'],
			PRODUCT: [
				'PRODUCT',
				'CREATE_PRODUCT',
				'CATEGORY',
				'UNITY',
				// 'PRINT_BARRE_CODE',
				// 'PRINT_QRCODE',
				'PRICE_CATEGORY'
			],
			ORDERS_MANAGEMENT: [
				'POS',
				'ORDERS_MANAGEMENT',
				'DELIVERY_VOUCHER',
				'CREDIT_MEMO',
				'QUOTE',
				'PROFORMA_INVOICE',
				'ORDER_CALCULATOR',
				'CLIENT',
				'ADD_CLIENT'
			],
			VENDOR_MANAGEMENT: ['TRANSACTIONS', 'VENDOR_MANAGEMENT', 'ADD_TRANSACTIONS'],
			STOCK_MANAGEMENT: [
				// 'POS',
				'STOCK_MANAGEMENT',
				'CREATE_PURCHASE_ORDER',
				// 'LOW_STOCK',
				// 'STOCK_EXPIRE',
				'PURCHASE_INVOICE',
				'PURCHASE_ORDER',
				'ENTRY_SLIP',
				'RECEIVING_SLIP',
				'RETURN_SLIP',
				'Histories',
				'SUPPLIER',
				'CREATE_SUPPLIER'
			],
			BOOKING_MANAGEMENT: ['BOOKING_MANAGEMENT', 'CALENDAR', 'Histories', 'BOOKING_MODEL', 'VEHICLE'],
			TRANSACTION_MANAGEMENT: ['TRANSACTION_MANAGEMENT', 'Histories'],
			EXPENSE_MANAGEMENT: [
				'EXPENSE_MANAGEMENT',
				'EXPENSE_CALCULATOR',
				'Histories',
				'CASH_JOURNAL',
				'LOAD',
				'LOAD_CATEGORY',
				'PAYMENT_METHODS',
				'PAYMENT_SOURCE',
				'CHEQUE',
				'CHARGES_FIXE'
			],
			HUMAN_RESOURCE: ['SALARY_MANAGEMENT', 'ABSENCE_TRACKER', 'SALARY_HISTORY', 'HUMAN_RESOURCE'],
			INVOICE_MANAGEMENT: ['INVOICE_MANAGEMENT', 'INVOICE_MODEL'],
			TURNOVER_MANAGEMENT: ['TURNOVER_MANAGEMENT', 'Histories'],
			SHIPPING_MANAGEMENT: ['SHIPPING_MANAGEMENT', 'PICKUP_REQUEST', 'Histories'],
			CHART_MODEL: ['CHART_MODEL'],
			API_INTEGRATION_MODEL: ['API_INTEGRATION_MODEL'],
			APPLICATIONS: ['APPLICATIONS']
		};
		let sections = MenuSection.map(section => {
			const order = moduleOrder[section.code] || [];
			section.modules.sort((a, b) => {
				const aIndex = order.indexOf(a.code) ?? -1;
				const bIndex = order.indexOf(b.code) ?? -1;
				if (aIndex === -1 && bIndex === -1) return a.code.localeCompare(b.code);
				if (aIndex === -1) return 1;
				if (bIndex === -1) return -1;
				return aIndex - bIndex;
			});
			return section;
		});
		// 🔹 Étape 2 — Trier les sections selon sectionOrder
		const sectionOrder = Object.keys(moduleOrder);
		sections.sort((a, b) => {
			const aIndex = sectionOrder.indexOf(a.code);
			const bIndex = sectionOrder.indexOf(b.code);
			if (aIndex === -1 && bIndex === -1) return a.code.localeCompare(b.code);
			if (aIndex === -1) return 1;
			if (bIndex === -1) return -1;
			return aIndex - bIndex;
		});
		const finalMenuItem = sections.flatMap(section => [{ headTitle1: section.headTitle }, ...section.modules]);
		this.menuItems.push(...finalMenuItem);
	}

	getChildrenByUserRoleOldVersion(routes, project) {
		let newRoutes;
		// filter activated applications by project
		routes = cloneDeep(routes).filter(route => !route?.code || project?.applications?.includes(route?.code));
		if (this.roleService.hasOwnerAccess()) {
			newRoutes = routes.map(route => {
				route.path = route.path + '/' + project?._id;
				if (route?.children?.length) {
					route.children = route.children.map(child => ({
						...child,
						path: child?.path?.toString()?.replace(':projectId', project?._id)
					}));
				}
				if (route?.childApp?.length) {
					route.children = route?.childApp?.map(child => ({
						...child,
						path: child?.path?.toString()?.replace(':projectId', project?._id)
					}));
				}
				return route;
			});
		} else {
			const projectComponentAccess = this.currentUserRole.access.find(access => access.project === project?._id);
			newRoutes = routes
				.map(route => {
					route.path = route.path + '/' + project?._id;
					if (route?.children?.length) {
						route.children = route.children.map(child => ({
							...child,
							path: child?.path?.toString()?.replace(':projectId', project?._id)
						}));
					}
					if (route?.childApp?.length) {
						route.childApp = route?.childApp?.map(child => ({
							...child,
							path: child?.path?.toString()?.replace(':projectId', project?._id)
						}));
					}
					return route;
				})
				.filter(route => {
					const componentRoute = projectComponentAccess.componentAccess.find(
						ComponentAccess => ComponentAccess.route == route.route
					);
					if (componentRoute?.isActive) {
						if (componentRoute?.childComponents?.length && route?.childApp?.length) {
							route.children = [];
							route?.childApp?.map(child => {
								const isActiveChildApp = componentRoute.childComponents.some(
									actionAuthorized =>
										actionAuthorized?.isActive && actionAuthorized?.name == child?.name
								);
								if (isActiveChildApp) route.children.push(child);
							});
							return true;
						}
						if (route?.children?.length) {
							route.children = route.children.filter(child => {
								const action = route.childRoute.find(
									childRoute => childRoute.route === child?.childRoute
								);
								if (action) {
									return componentRoute.actions.some(
										actionAuthorized =>
											actionAuthorized.name === action?.actionName && actionAuthorized.isActive
									);
								}
								return true;
							});
							return true;
						} else {
							return true;
						}
					}
					return false;
				});
		}
		return newRoutes;
	}

	getChildrenByUserRole(routes, project) {
		let newRoutes;
		// filter activated applications by project
		// routes = cloneDeep(routes).filter(
		// 	route => !route?.code || route?.code === 'DASHBOARD' || project?.applications?.includes(route?.code)
		// );
		routes = cloneDeep(routes)
			.map(route => {
				// if this route has children
				if (Array.isArray(route.children) && route?.children?.length > 0) {
					const filteredChildren = route.children.filter(child =>
						project?.applications?.includes(child.appCode)
					);

					if (filteredChildren?.length > 0) {
						return { ...route, children: filteredChildren };
					}

					return null; // route non autorisée
				}

				// else, verify by route.code
				if (!route?.code || route?.code === 'DASHBOARD' || project?.applications?.includes(route.code)) {
					return route;
				}

				return null;
			})
			.filter(Boolean);
		if (this.roleService.hasOwnerAccess()) {
			newRoutes = routes.map(route => {
				route.path = route.path + '/' + project?._id;
				if (route?.children?.length) {
					route.children = route.children.map(child => ({
						...child,
						path: child?.path?.toString()?.replace(':projectId', project?._id)
					}));
				}
				if (route?.childApp?.length) {
					route.children = route?.childApp?.map(child => ({
						...child,
						path: child?.path?.toString()?.replace(':projectId', project?._id)
					}));
				}
				return route;
			});
		} else {
			const projectComponentAccess = this.currentUserRole.access.find(access => access.project === project?._id);
			newRoutes = routes
				.map(route => {
					route.path = route.path + '/' + project?._id;
					if (route?.children?.length) {
						route.children = route.children.map(child => ({
							...child,
							path: child?.path?.toString()?.replace(':projectId', project?._id)
						}));
					}
					if (route?.childApp?.length) {
						route.childApp = route?.childApp?.map(child => ({
							...child,
							path: child?.path?.toString()?.replace(':projectId', project?._id)
						}));
					}
					return route;
				})
				.filter(route => {
					if (Array.isArray(route?.children) && route?.children?.length > 0) {
						route.children = route?.children?.filter(child => {
							const componentRoute = projectComponentAccess.componentAccess.find(
								ComponentAccess => ComponentAccess.code == child.appCode
							);

							if (componentRoute?.isActive) {
								const action = route.childRoute.find(
									childRoute => childRoute.route === child?.childRoute
								);
								if (action) {
									return componentRoute.actions.some(
										actionAuthorized =>
											actionAuthorized.name === action?.actionName && actionAuthorized.isActive
									);
								}
								return true;
							}
							return false;
						});
						return !!route?.children?.length;
					} else {
						const componentRoute = projectComponentAccess.componentAccess.find(
							ComponentAccess => ComponentAccess.route == route.route
						);
						if (componentRoute?.isActive) {
							if (componentRoute?.childComponents?.length && route?.childApp?.length) {
								route.children = [];
								route?.childApp?.map(child => {
									const isActiveChildApp = componentRoute.childComponents.some(
										actionAuthorized =>
											actionAuthorized?.isActive && actionAuthorized?.name == child?.name
									);
									if (isActiveChildApp) route.children.push(child);
								});
								return true;
							}

							if (route?.children?.length) {
								route.children = route.children.filter(child => {
									const action = route.childRoute.find(
										childRoute => childRoute.route === child?.childRoute
									);
									if (action) {
										return componentRoute.actions.some(
											actionAuthorized =>
												actionAuthorized.name === action?.actionName &&
												actionAuthorized.isActive
										);
									}
									return true;
								});
								return true;
							} else {
								return true;
							}
						}
						return false;
					}
				});
		}

		return newRoutes;
	}

	// Active Nave state
	setNavActive(item) {
		this.menuItems.filter(menuItem => {
			if (menuItem !== item) {
				menuItem.active = false;
			}
			if (menuItem?.children?.length && menuItem.children.includes(item)) {
				menuItem.active = true;
			}
			if (menuItem.children?.length) {
				menuItem.children.filter(submenuItems => {
					if (submenuItems.children && submenuItems.children.includes(item)) {
						menuItem.active = true;
						submenuItems.active = true;
					}
				});
			}
		});
	}

	// Click Toggle menu
	toggletNavActive(item) {
		if (!item.active) {
			this.menuItems.forEach(a => {
				if (this.menuItems.includes(item)) {
					a.active = false;
				}
				if (!a.children) {
					return false;
				}
				a.children.forEach(b => {
					if (a.children.includes(item)) {
						b.active = false;
					}
				});
			});
		}
		item.active = !item.active;
	}

	// For Horizontal Menu
	scrollToLeft() {
		if (this.margin >= -this.width) {
			this.margin = 0;
			this.leftArrowNone = true;
			this.rightArrowNone = false;
		} else {
			this.margin += this.width;
			this.rightArrowNone = false;
		}
	}

	scrollToRight() {
		if (this.margin <= -3051) {
			this.margin = -3464;
			this.leftArrowNone = false;
			this.rightArrowNone = true;
		} else {
			this.margin += -this.width;
			this.leftArrowNone = false;
		}
	}

	navigateToFirstActiveRoute() {
		const currentUserRole = this.currentUser?.userRole?.role as Role;
		return this.userService.getNavigationRouteUrlByRole(this.currentUser?.roles[0], currentUserRole);
	}
}
